
import unsplashTeam from "@/assets/working.png";
import { SectionTitle } from "@/components/section-title";

export function About() {
    return (
        <section id="sobre-nos" className="grid gap-8 overflow-hidden rounded-3xl border border-slate-200 dark:border-white/10 bg-gradient-to-r from-slate-50 via-slate-100 to-slate-50 dark:from-white/5 dark:via-white/10 dark:to-white/5 p-8 shadow-sm dark:shadow-[0_30px_120px_rgba(0,0,0,0.35)] backdrop-blur md:grid-cols-[1fr_1.1fr] scroll-mt-28">
            <div className="relative flex items-center justify-center min-h-[300px]">
                <div className="absolute inset-6 rounded-[32px] bg-gradient-to-br from-cyan-400/20 via-purple-500/15 to-transparent blur-3xl" />

                <img src={unsplashTeam} alt="Equipe trabalhando" className="relative z-10 rounded-2xl border border-slate-200 dark:border-white/10 object-cover w-full h-full" loading="lazy" />
            </div>
            <div className="flex flex-col gap-6 justify-center">
                <SectionTitle eyebrow="Quem somos" title="Quem é a CodeBoost?" align="left" />
                <p className="text-slate-700 dark:text-slate-200/75 text-lg leading-relaxed">
                    A CodeBoost é uma empresa especializada em Inteligência Artificial, fundamentada em engenharia de software e arquitetura de sistemas.
                    Nosso foco é entregar soluções de mercado com alto rigor de qualidade, performance e eficiência.
                </p>

                <div className="grid gap-4">
                    <div className="p-4 rounded-xl border border-slate-200 dark:border-white/10 bg-white dark:bg-white/5 hover:bg-slate-50 dark:hover:bg-white/10 transition-colors">
                        <h3 className="font-semibold text-slate-900 dark:text-white mb-2 text-lg">Missão</h3>
                        <p className="text-slate-600 dark:text-slate-300/80">Projetar e implementar sistemas de IA robustos que priorizam performance, qualidade técnica e viabilidade de mercado</p>
                    </div>
                    <div className="p-4 rounded-xl border border-slate-200 dark:border-white/10 bg-white dark:bg-white/5 hover:bg-slate-50 dark:hover:bg-white/10 transition-colors">
                        <h3 className="font-semibold text-slate-900 dark:text-white mb-2 text-lg">Visão</h3>
                        <p className="text-slate-600 dark:text-slate-300/80">Ser reconhecida pela excelência técnica em IA, tornando-se o parceiro fundamental para empresas que buscam converter inovações tecnológicas em crescimento real.</p>
                    </div>
                </div>
            </div>
        </section>
    );
}
